var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargoBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.349,
    height: 83.991,
    viewBox: "0 0 99.349 83.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6087",
    "data-name": "Group 6087",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 5.865,
    cy: 5.865,
    r: 5.865,
    transform: "translate(28.899)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M128.413,105.835a8.728,8.728,0,1,1-8.728,8.728,8.736,8.736,0,0,1,8.728-8.728m0-3.505a12.233,12.233,0,1,0,12.233,12.233,12.232,12.232,0,0,0-12.233-12.233Z",
    transform: "translate(-48.311 -44.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_410",
    "data-name": "Line 410",
    y1: 3.534,
    x2: 1.986,
    transform: "translate(15.954 53.82)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_411",
    "data-name": "Line 411",
    x2: 5.293,
    transform: "translate(25.049 68.191)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412",
    "data-name": "Line 412",
    x1: 12.005,
    transform: "translate(49.041 44.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_413",
    "data-name": "Line 413",
    y1: 9.02,
    x2: 9.014,
    transform: "translate(51.437 46.687)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_414",
    "data-name": "Line 414",
    x2: 8.885,
    transform: "translate(51.507 68.191)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6086",
    "data-name": "Group 6086",
    transform: "translate(62.104 33.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M167.5,124v0Z",
    transform: "translate(-131.754 -86.335)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M106.31,59.61V97.278h.4v-.123c0-10.334,7.91-18.711,17.671-18.711s17.671,8.377,17.671,18.711V59.61Z",
    transform: "translate(-106.31 -59.61)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M13.121,102.785A9.615,9.615,0,1,1,3.505,112.4a9.627,9.627,0,0,1,9.616-9.615m0-3.505A13.121,13.121,0,1,0,26.241,112.4,13.12,13.12,0,0,0,13.121,99.28Z",
    transform: "translate(0 -43.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_415",
    "data-name": "Line 415",
    x1: 13.202,
    transform: "translate(58.61 33.07)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M44.965,50.176a2.235,2.235,0,0,0,.263.263,1.168,1.168,0,0,0,1,.6l14.26.2.053-6.35-11.053-.152a2.629,2.629,0,0,0-.245-.38L38.878,31.249a5.68,5.68,0,0,0-1.84-1.326,4.6,4.6,0,0,0-5.421,2.255l-11.175,19.4a4.54,4.54,0,0,0,.958,5.678,4.868,4.868,0,0,0,.83.619L44.235,70.582V88.866h6.928V64.623s-.006-.053-.006-.076a1.183,1.183,0,0,0-.572-1.127l-19.9-11.491L36.91,41.145l8.05,9.031Z",
    transform: "translate(-8.25 -14.092)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoBike);
export default __webpack_public_path__ + "static/media/CargoBike.66743e782b45b0bb7aae22905c4d00c2.svg";
export { ForwardRef as ReactComponent };